import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ChartDataSets, ChartOptions} from 'chart.js';
import {BaseChartDirective, Color, Label} from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import {Subscription} from 'rxjs';
import {HouseholdService} from '@core/state/household';

@Component({
  selector: 'ngx-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() lineChartData: ChartDataSets[] = [
    {data: [25, 50, 75], label: 'Series A', fill: 1},
    {data: [10, 20, 30], label: 'Series B', fill: 1},
    {data: [0, 0, 0], label: 'Series C', fill: 1},
  ];
  @Input() lineChartLabels: Label[] = ['jun', 'aug', 'sep'];
  @Input() maxValue = 100;
  @Input() minValue = 0;

  @ViewChild('monthly') monthlyChart: BaseChartDirective;
  public randomizer: Subscription = new Subscription();

  public lineChartOptions: (ChartOptions & { annotation: any });
  public lineChartColors: Color[] = [
    { // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(117, 92, 163, 1)',
      pointBackgroundColor: 'rgba(117, 92, 163, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // grey
      backgroundColor: 'rgba(208, 250, 217, 0.8)',
      borderColor: 'rgba(38, 231, 79, 1)',
      pointBackgroundColor: 'rgba(38, 231, 79, 1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [pluginAnnotations];

  // events
  public chartClicked({event, active}: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({event, active}: { event: MouseEvent, active: {}[] }): void {
  }

  constructor(
    private householdService: HouseholdService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.setLineChartOptions();
  }

  setLineChartOptions() {
    this.lineChartOptions = {
      responsive: true,
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {}
        }],
        yAxes: [
          {
            id: 'y-axis-0',
            position: 'left',
            ticks: {
              beginAtZero: false,
              max: this.maxValue,
              min: this.minValue,
              stepSize: 250
            },
            gridLines: {
              display: false
            }
          }
        ]
      },
      annotation: {},
      elements: {
        line: {
          tension: 0.000001,
          borderWidth: 0.7
        },
        point: {
          radius: 5
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        onClick: (event, data) => {
          if (data.text === 'Bruto kosten per maand') {
            this.router.navigate(['dashboard', 'fixed-charges']);
          } else {
            // This part will just toggle the strike-through effect of the legend.
            let chart = this.monthlyChart;
            let meta = chart.datasets[data.datasetIndex];
            meta.hidden = !meta.hidden;

            chart.update();
          }
        }
      },

    };
  }

  ngOnDestroy(): void {
    this.randomizer.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setLineChartOptions();
  }

}
